// Angular/ 3rd party imports
import { AccordionModule } from 'primeng/accordion';
import { CheckboxModule } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';

// ISPM imports
import { AggregatorModule } from '@ispm-client/modules/aggregator/aggregator.module';
import { CoreModule } from '@ispm/core/core.module';
import { DynamicFormModule } from '@ispm/dynamic-form/dynamic-form.module';
import { EventService } from "@ispm-client/modules/events/services/event.service";
import { EventsModule } from "@ispm-client/modules/events";
import { FileModule } from '@ispm-client/modules/file-module/file.module';
import { LabOrderContentComponent } from './components/lab-order-content/lab-order-content.component';
import { LabOrderManagerComponent } from './components/lab-order-manager/lab-order-manager.component';
import { LayoutModule } from '@ispm/layout/layout.module';
import { OrderContentComponent } from '@ispm-client/modules/orders/components/order-content/order-content.component';
import { OrderListComponent } from '@ispm-client/modules/orders/components/order-list/order-list.component';
import { OrderManagerComponent } from '@ispm-client/modules/orders/components/order-manager/order-manager.component';
import { orderReducer } from './store/reducers/order.reducer';
import { OrderService } from '@ispm-client/modules/orders/services/order.service';
import { OrderSFTPService } from './services/order.sftp.service';
import { SharedModule } from '@ispm/shared/shared.module';
import { WidgetsModule } from '@ispm/widgets/widgets.module';
import {WorklistModule} from "../../app/worklist/worklist.module";

@NgModule({
  declarations: [
    LabOrderContentComponent,
    LabOrderManagerComponent,
    OrderContentComponent,
    OrderListComponent,
    OrderManagerComponent
  ],
  imports: [
    SharedModule,
    CoreModule,
    DynamicFormModule,
    WidgetsModule,
    AggregatorModule,
    LayoutModule,
    FileModule,
    AccordionModule,
    CheckboxModule,
    FormsModule,
    EventsModule,
    WorklistModule,
    StoreModule.forFeature('orders', orderReducer)
  ],
  providers: [OrderService, EventService, OrderSFTPService],
  exports: [
    OrderManagerComponent,
    OrderListComponent,
    OrderContentComponent
  ]
})
export class OrdersModule { }
